<template>
    <rkm-table
        :fields="fields"
        :items="items"
        hide-filters
        ref="RkmTable"
    >
        <template v-slot:cell(procedimento)="row">
            <span
                :title="row.item.procedimento.nome"
                v-rkm-tooltip.hover
            >
                {{ row.item.procedimento.codigo | formatProcedimento }}
            </span>
        </template>

        <template v-slot:cell(ocupacao)="row">
            <span
                :title="row.item.ocupacao.nome"
                v-rkm-tooltip.hover
            >
                {{ row.item.ocupacao.codigo }}
            </span>
        </template>

        <template v-slot:cell(actions)="row">
            <rkm-button
                :disabled="row.item.exportacaoId && row.item.inconsistencias.length === 0"
                @click="$emit('edit', row.item)"
                color="primary"
                small
                title="Editar"
                authorize="update-bpa-procedimento-consolidado"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                :disabled="row.item.exportacaoId && row.item.inconsistencias.length === 0"
                @click="handleDestroy(row.item)"
                color="danger"
                small
                title="Excluir"
                authorize="destroy-bpa-procedimento-consolidado"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Filters.
import formats from '@/filters/formats'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    created() {
        this.repositories = {
            procedimentoConsolidado: this.getConectaSusRepository('bpa.procedimentoConsolidado'),
        }
    },
    data: () => ({
        fields: [
            { key: 'origem', label: 'Origem' },
            { key: 'unidade.nomeFantasia', label: 'Unidade' },
            { key: 'competencia', label: 'Competência' },
            { key: 'procedimento', label: 'Procedimento' },
            { key: 'ocupacao', label: 'CBO' },
            { key: 'quantidade', label: 'Quantidade' },
            { key: 'idade', label: 'Idade' },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
        items: [],
    }),
    filters: {
        ...formats,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            const request = {
                with: ['inconsistencias', 'ocupacao', 'procedimento', 'unidade'],
                origem: this.model.origem,
                unidadeId: this.model.unidadeId,
                procedimentoId: this.model.procedimentoId,
                ocupacaoId: this.model.ocupacaoId,
                competencia: this.model.competencia,
                idade: this.model.idade,
            }

            this.repositories.procedimentoConsolidado.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.items = response.data
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleDestroy(item) {
            const request = { origem: item.origem }

            const destroy = () => this.repositories.procedimentoConsolidado.destroy(item.id, this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.items.splice(item, 1)
                })

            this.showDeleteConfirmation('Deseja realmente excluir o procedimento?', destroy)
        },
    },
    mixins: [ error, repository, stringCase ],
    mounted() {
        this.load()
    },
    props: {
        model: { type: Object, required: true },
    },
}
</script>